/*
 * Copyright (c) 2023 Irian Software Development SRL. All Rights Reserved.
 * This software is the proprietary information of Irian Software Development SRL.
 * Use is subject to license and non-disclosure terms
 */

import { ListPage } from './list-page';
import { Entity } from './entity.interface';
import { TranslateService } from '@ngx-translate/core';
import * as _ from 'lodash';
import { EditableEntityService } from './editable-entity-service.interface';
import { ConfirmationService, MessageService } from 'primeng/api';

export class ListPageWithEdit<T extends Entity> extends ListPage<T> {
  addNew: boolean | undefined = undefined;

  selectedItem: T | undefined = undefined;
  selectedRowUuid: string | undefined = undefined;

  // e nevoie de tip pentru add (ca sa faci new)
  constructor(
    private readonly entityType,
    entityService: EditableEntityService<T>,
    translateService: TranslateService,
    messageService: MessageService,
    confirmationService: ConfirmationService,
    deleteEntityMsgKey?: string
  ) {
    super(
      entityService,
      translateService,
      messageService,
      confirmationService,
      deleteEntityMsgKey
    );
  }

  add() {
    if (this.selectedItem == null) {
      this.addNew = true;
      this.selectedItem = new this.entityType();
    }
  }

  cancelAdd() {
    this.addNew = false;
    this.selectedItem = null;
  }

  rowEdit(item: T) {
    this.selectedRowUuid = item.uuid;
    this.selectedItem = _.cloneDeep(item);
  }

  rowEditCancel() {
    this.selectedRowUuid = null;
    this.selectedItem = null;
  }

  save(callback: () => void) {
    (<EditableEntityService<T>>this.entityService)
      .updateEntity(this.selectedItem)
      .subscribe(
        () => {
          this.selectedItem = null;
          this.selectedRowUuid = null;
          this.addNew = false;
          this.addMessage({
            severity: 'success',
            summary: 'Selected entry edited',
          });

          if (callback) {
            callback();
          }
        },
        () => {
          this.addMessage({
            severity: 'error',
            summary: 'Error updating selected entry!',
          });
        }
      );
  }

  create(callback: () => void) {
    (<EditableEntityService<T>>this.entityService)
      .createEntity(this.selectedItem)
      .subscribe(
        () => {
          this.selectedItem = null;
          this.addMessage({
            severity: 'success',
            summary: 'New entry created',
          });
          this.addNew = false;

          if (callback) {
            callback();
          }
        },
        () => {
          this.addMessage({
            severity: 'error',
            summary: 'Error creating new entry!',
          });
        }
      );
  }
}
